var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageDashboard"}},[(_vm.visibleSupportLayout)?_c('support-layout'):_vm._e(),(_vm.visibleSpecialistLayout)?_c('specialist-layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }